import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';
import type { RouterContext } from '~/router-context';
import { PostHogProvider } from '~/components/posthog-provider';
import { ConfirmProvider } from '~/components/confirm-dialog';
import { NotFound } from '~/components/not-found';
import { AppToaster } from '~/components/ui/toaster';
import { TooltipProvider } from '~/components/ui/tooltip';
import { TRPCProvider } from '~/lib/trpc';
import i18n from '~/i18n';

export const Route = createRootRouteWithContext<RouterContext>()({
  notFoundComponent: NotFound,
  component: RootComponent,
});

function RootComponent() {
  const { queryClient, trpcClient } = Route.useRouteContext();

  return (
    <PostHogProvider>
      <QueryClientProvider client={queryClient}>
        <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
          <I18nextProvider i18n={i18n}>
            <TooltipProvider delayDuration={300}>
              <ConfirmProvider>
                <Outlet />
                <AppToaster />
              </ConfirmProvider>
            </TooltipProvider>
          </I18nextProvider>
        </TRPCProvider>
      </QueryClientProvider>
    </PostHogProvider>
  );
}
